<template>
  <v-navigation-drawer
    v-model="state"
    class="elevation-1"
    app
    :permanent="$vuetify.breakpoint.smAndUp"
    :temporary="$vuetify.breakpoint.xs"
  >
    <div
      class="amber darken-1 d-flex align-center px-6"
      :class="{
        'mobile-drawer-logo': $vuetify.breakpoint.xs,
        'px-7': $vuetify.breakpoint.xs
      }"
    >
      <v-img :height="imageHeight" src="../../assets/logo.svg" contain position="left"></v-img>
    </div>
    <StudentToolbar></StudentToolbar>
    <TeacherToolbar></TeacherToolbar>
    <AdminToolbar></AdminToolbar>
    <ReportToolbar></ReportToolbar>
  </v-navigation-drawer>
</template>
<script>
import TeacherToolbar from '@/components/layout/TeacherToolbar.vue'
import AdminToolbar from '@/components/layout/AdminToolbar.vue'
import ReportToolbar from '@/components/layout/ReportToolbar.vue'
import StudentToolbar from '@/components/layout/StudentToolbar.vue'
export default {
  props: {
    drawer: { type: Boolean }
  },
  data() {
    return {
      state: false
    }
  },
  watch: {
    drawer() {
      this.state = true
    }
  },
  components: { ReportToolbar, StudentToolbar, TeacherToolbar, AdminToolbar },
  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '32px'
        default:
          return '64px'
      }
    }
  }
}
</script>

<style scoped>
.mobile-drawer-logo {
  height: 64px;
}
</style>
